import useSWR from 'swr'
import {
  LibraryCollectionTopicItem,
  LibraryCollectionTopicsResponse,
} from '@digital-twins/shared-types'

import { libraryCollectionsApi } from '@/lib/api'

import { LIBRARY_COLLECTION_TOPICS_SWR_KEY } from './useLibraryCollection'

export interface UseCollectionTopicsResult {
  topics: Array<LibraryCollectionTopicItem>
  /** False hides the Topics area. */
  socialListeningEnabled: boolean
  isLoading: boolean
  hasError: boolean
  refresh: () => Promise<unknown>
}

/**
 * The collection's Topics over `GET /library/collections/:token/topics`.
 * Until the answer lands, social listening reads as off, so the area never
 * flashes in for an org without it.
 */
export function useCollectionTopics(token: string | null): UseCollectionTopicsResult {
  const { data, error, isLoading, mutate } = useSWR<LibraryCollectionTopicsResponse>(
    token ? [LIBRARY_COLLECTION_TOPICS_SWR_KEY, token] : null,
    () => libraryCollectionsApi.listTopics(token as string),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  )
  return {
    topics: data?.items ?? [],
    socialListeningEnabled: data?.socialListeningEnabled ?? false,
    isLoading: Boolean(token) && isLoading,
    hasError: Boolean(error),
    refresh: () => mutate(),
  }
}
